module.exports = __webpack_public_path__ + "img/environment-txt.c52775da.png";